// reducer.js
import {
  SHARE_RESUME_TEMPLATE_REQUEST,
  SHARE_RESUME_TEMPLATE_SUCCESS,
  SHARE_RESUME_TEMPLATE_FAILURE,
} from "../../actionTypes";

const initialState = {
  data: {},
  status: false,
  isLoading: false,
  message: "",
};

const shareResumeTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHARE_RESUME_TEMPLATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case SHARE_RESUME_TEMPLATE_SUCCESS:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        data: action.payload.data,
      };
    case SHARE_RESUME_TEMPLATE_FAILURE:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default shareResumeTemplateReducer;
